import React, { useEffect, useState } from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { Box } from "@mui/material";

import '../../styles/shop.scss';
import { ShopCenter } from "./ShopCenter";
import { UseProductFilter, productsBase } from '../../services/filterService';

import ProductsService from "../../services/productsService";
import { Header } from "../common/Header";
import { useCart } from "../../context/CartContext";

import { TopBar } from "../common/TopBar";


/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const Shop = ( props ) => {

    const isAuthenticated = useIsAuthenticated();
    const { fetchCart } = useCart();
  
    useEffect(() => {
      if (isAuthenticated) {
        fetchCart();
      }
    }, [isAuthenticated]);
  
    const updateCartItemCount = async () => {
        await fetchCart();
      };

    const productService = ProductsService();
    const [products, setProducts] = useState(productsBase);
    const [productLoaded, setProductLoaded] = useState(false);
    
    const [search, setSearch] = useState("");
    const [filter, setFilter] = UseProductFilter();

    const [showItem, setShowItem] = useState(false);

    useEffect(() => {
      
        const initState = async () => {
          setProductLoaded(false);
          setProducts(await productService.getProducts(search, filter));
          setProductLoaded(true);
          setShowItem(false);
         
        };
        initState();
      }, []);

    const updateProducts = async (newFilter, newSearch) => {
        setProductLoaded(false);
        setProducts(await productService.getProducts(newSearch, newFilter));
        setProductLoaded(true);
        setShowItem(false);
    }

    const updateFilter = async (facetSelections) => {
        // facetSelections is just { categories, brand, radius, wall, diameter }
        // from ShopCategories. Merge it on top of the current filter so we keep
        // sort/sortOrder/pageSize; reset page to 1 because the result set changes.
        const next = { ...filter, ...facetSelections, page: 1 };
        setFilter(next);
        updateProducts(next, search);
        setShowItem(false);
    };

    const onPageSizeChange = async (pageSizeInput) => {
        if(pageSizeInput != filter.pageSize){
            let a = Object.assign({},filter,{pageSize: pageSizeInput, page: 1});
            setFilter(a);
            updateProducts(a, search);
            setShowItem(false);
        }
    };

    const onPageChange = (newPage) => {
        if(filter.page != newPage){
            console.log("onPageChange",newPage, filter.page);
            let a = Object.assign({},filter,{page: newPage});
            setFilter(a);
            updateProducts(a, search);
            setShowItem(false);
        }
    };

    const onSortChange = async (newSort) => {
        if(filter.sort != newSort){
            console.log("onSortChange",newSort);
            let a = Object.assign({},filter,{sort: newSort.sort, sortOrder: newSort.sortOrder, page: 1});
            setFilter(a);
            updateProducts(a, search);
            setShowItem(false);
        }
    };

    const onSearchChange = async (newSearch) => {
        if(search != newSearch){
            console.log("onSearchChange",newSearch);
            let a = Object.assign({},filter,{page: 1});
            setFilter(a);
            setSearch(newSearch);
            updateProducts(filter, newSearch);
            setShowItem(false);
        }
    };

    const [showCategories, setShowCategories] = useState(true);

  const toggleCategories = () => {
    setShowCategories(!showCategories);
  };

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
            <Header />
            <TopBar />
            <Box sx={{ px: { xs: 2, md: 4 } }}>
                <ShopCenter
                    updateCartItemCount={updateCartItemCount}
                    onSearchChange={onSearchChange}
                    search={search}
                    onPageChange={onPageChange}
                    loadingProducts={productLoaded}
                    pages={products.pages}
                    currentPage={products.page}
                    products={products}
                    onPageSizeChange={onPageSizeChange}
                    onSortChange={onSortChange}
                    showItem={showItem}
                    setShowItem={setShowItem}
                    updateFilter={updateFilter}
                    initialFilter={filter}
                />
            </Box>
        </Box>
    );
};